module.exports = __webpack_public_path__ + "img/empty-cart.cdae0b37.svg";